import { render, staticRenderFns } from "./flipcard.vue?vue&type=template&id=7d4cc485&scoped=true"
import script from "./flipcard.vue?vue&type=script&lang=js"
export * from "./flipcard.vue?vue&type=script&lang=js"
import style0 from "./flipcard.vue?vue&type=style&index=0&id=7d4cc485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4cc485",
  null
  
)

export default component.exports